module.exports = __webpack_public_path__ + "static/img/jeecg_ad_text.013a84c3.png";